import React from 'react'
import './footer.css'
import {BsGithub, BsLinkedin} from 'react-icons/bs'
import {HiOutlineMail} from 'react-icons/hi'

const Footer = () => (
  <footer>
    <a href="#top" className="footer__logo">Michael Fang</a>
    <ul className="permalinks">
      <li><a href="#about">About</a></li>
      <li><a href="#experience">Experience</a></li>
      <li><a href="#portfolio">Projects</a></li>
      <li><a href="#contact">Contact</a></li>
    </ul>
    <div className="footer__socials">
      <a href="https://www.linkedin.com/in/michael-d-fang/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><BsLinkedin /></a>
      <a href="https://github.com/FlyinPandaa" target="_blank" rel="noopener noreferrer" aria-label="GitHub"><BsGithub /></a>
      <a href="mailto:mikefang456@gmail.com" aria-label="Email Michael"><HiOutlineMail /></a>
    </div>
    <div className="footer__copyright"><small>&copy; {new Date().getFullYear()} Michael Fang.</small></div>
  </footer>
)

export default Footer
